import routerMap from '../router/router-map'

export default (name, remoto = 'LOCAL') => {
  if (name.indexOf('/') > -1) {
    name = name.replace('/', '');
  }
  if (name.indexOf('?') > -1) {
    name = (name.split('?'))[0]
  }
  let baseURL;
  if(remoto && remoto != 'LOCAL'){
    // 其他跳转
    if(remoto == 'BASIC'){
      console.log('--------14------------------------------------------', process.env.NODE_ENV);
      // 钱包H5 本地
      baseURL = process.env.NODE_ENV === 'production' ?
        `/spread/${routerMap[name]}.html#` :
        process.env.NODE_ENV === 'LOCAL' ?
          `http://localhost:3115/${routerMap[name]}.html#` :
          `/spread/${routerMap[name]}.html#`;
      console.log('--------21------------------------------------------', baseURL);
    }
  }else{
    baseURL = process.env.NODE_ENV === 'production' 
      ? '/mall/index.html#' :
      process.env.NODE_ENV =='LOCAL' ?
        `http://localhost:3113/index.html#` :
        '/mall/index.html#'

        // ? 'https://walletapidev.bitdisk.io:4443/SEJ/#'
        //  : 'https://walletapi.bitdisk.io/SEJ/#';
  }
  
  return baseURL;
}


// WEBPACK FOOTER //
// ./src/utils/getUrl.js